import { render, staticRenderFns } from "./CourseCoopAutoComplete.vue?vue&type=template&id=09644eb4&"
import script from "./CourseCoopAutoComplete.vue?vue&type=script&lang=js&"
export * from "./CourseCoopAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports